var _templateObject, _templateObject2;

var _excluded = ["children", "variant", "analyticsName", "disabled", "loading", "loadingText", "onClick", "type", "success", "onMouseDown"];

function cov_x1j7yn8w6() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Button/Button.tsx";
  var hash = "dbec6f902a54d2e0191b5334a6073c295b391fdd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Button/Button.tsx",
    statementMap: {
      "0": {
        start: {
          line: 74,
          column: 15
        },
        end: {
          line: 158,
          column: 1
        }
      },
      "1": {
        start: {
          line: 91,
          column: 23
        },
        end: {
          line: 91,
          column: 59
        }
      },
      "2": {
        start: {
          line: 92,
          column: 25
        },
        end: {
          line: 92,
          column: 76
        }
      },
      "3": {
        start: {
          line: 93,
          column: 31
        },
        end: {
          line: 93,
          column: 70
        }
      },
      "4": {
        start: {
          line: 94,
          column: 19
        },
        end: {
          line: 94,
          column: 66
        }
      },
      "5": {
        start: {
          line: 95,
          column: 24
        },
        end: {
          line: 95,
          column: 49
        }
      },
      "6": {
        start: {
          line: 96,
          column: 31
        },
        end: {
          line: 96,
          column: 53
        }
      },
      "7": {
        start: {
          line: 99,
          column: 32
        },
        end: {
          line: 104,
          column: 6
        }
      },
      "8": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 112,
          column: 32
        }
      },
      "9": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 110,
          column: 7
        }
      },
      "10": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 92
        }
      },
      "11": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "12": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 30
        }
      },
      "13": {
        start: {
          line: 120,
          column: 30
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "14": {
        start: {
          line: 130,
          column: 25
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "15": {
        start: {
          line: 131,
          column: 12
        },
        end: {
          line: 131,
          column: 96
        }
      },
      "16": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 156,
          column: 6
        }
      },
      "17": {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 144,
          column: 95
        }
      },
      "18": {
        start: {
          line: 145,
          column: 10
        },
        end: {
          line: 145,
          column: 32
        }
      },
      "19": {
        start: {
          line: 160,
          column: 0
        },
        end: {
          line: 166,
          column: 2
        }
      },
      "20": {
        start: {
          line: 174,
          column: 59
        },
        end: {
          line: 196,
          column: 1
        }
      },
      "21": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 195,
          column: 4
        }
      },
      "22": {
        start: {
          line: 198,
          column: 25
        },
        end: {
          line: 202,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 7
          },
          end: {
            line: 157,
            column: 3
          }
        },
        line: 90
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 106,
            column: 15
          }
        },
        loc: {
          start: {
            line: 106,
            column: 20
          },
          end: {
            line: 112,
            column: 5
          }
        },
        line: 106
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 7
          }
        },
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 96
          }
        },
        line: 131
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 143,
            column: 17
          },
          end: {
            line: 143,
            column: 18
          }
        },
        loc: {
          start: {
            line: 143,
            column: 24
          },
          end: {
            line: 146,
            column: 9
          }
        },
        line: 143
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 174,
            column: 59
          },
          end: {
            line: 174,
            column: 60
          }
        },
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 195,
            column: 4
          }
        },
        line: 175
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 41
          },
          end: {
            line: 91,
            column: 48
          }
        }, {
          start: {
            line: 91,
            column: 51
          },
          end: {
            line: 91,
            column: 59
          }
        }],
        line: 91
      },
      "1": {
        loc: {
          start: {
            line: 92,
            column: 25
          },
          end: {
            line: 92,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 49
          },
          end: {
            line: 92,
            column: 60
          }
        }, {
          start: {
            line: 92,
            column: 63
          },
          end: {
            line: 92,
            column: 76
          }
        }],
        line: 92
      },
      "2": {
        loc: {
          start: {
            line: 93,
            column: 31
          },
          end: {
            line: 93,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 93,
            column: 52
          },
          end: {
            line: 93,
            column: 56
          }
        }, {
          start: {
            line: 93,
            column: 59
          },
          end: {
            line: 93,
            column: 70
          }
        }],
        line: 93
      },
      "3": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 110,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 110,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 108
      },
      "4": {
        loc: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 21
          }
        }, {
          start: {
            line: 109,
            column: 25
          },
          end: {
            line: 109,
            column: 91
          }
        }],
        line: 109
      },
      "5": {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 116
      },
      "6": {
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 25
          }
        }, {
          start: {
            line: 131,
            column: 29
          },
          end: {
            line: 131,
            column: 96
          }
        }],
        line: 131
      },
      "7": {
        loc: {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 144,
            column: 23
          }
        }, {
          start: {
            line: 144,
            column: 27
          },
          end: {
            line: 144,
            column: 94
          }
        }],
        line: 144
      },
      "8": {
        loc: {
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 145,
            column: 17
          }
        }, {
          start: {
            line: 145,
            column: 21
          },
          end: {
            line: 145,
            column: 31
          }
        }],
        line: 145
      },
      "9": {
        loc: {
          start: {
            line: 150,
            column: 19
          },
          end: {
            line: 150,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 29
          },
          end: {
            line: 150,
            column: 54
          }
        }, {
          start: {
            line: 150,
            column: 57
          },
          end: {
            line: 150,
            column: 61
          }
        }],
        line: 150
      },
      "10": {
        loc: {
          start: {
            line: 153,
            column: 9
          },
          end: {
            line: 153,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 19
          },
          end: {
            line: 153,
            column: 57
          }
        }, {
          start: {
            line: 153,
            column: 60
          },
          end: {
            line: 153,
            column: 64
          }
        }],
        line: 153
      },
      "11": {
        loc: {
          start: {
            line: 154,
            column: 9
          },
          end: {
            line: 154,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 19
          },
          end: {
            line: 154,
            column: 37
          }
        }, {
          start: {
            line: 154,
            column: 40
          },
          end: {
            line: 154,
            column: 48
          }
        }],
        line: 154
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dbec6f902a54d2e0191b5334a6073c295b391fdd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_x1j7yn8w6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_x1j7yn8w6();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect } from 'react';
import { keyframes } from '@emotion/react';
import isNil from 'lodash/isNil';
import { useStyleConfig } from '../../system/utils';
import { forwardRef } from '@chakra-ui/system';
import { useMergeRefs } from '@chakra-ui/hooks';
import { useInView } from 'react-intersection-observer';
import { bricks } from '../../system/bricks.types';
import Box from '../Box';
import useMedia from '../../hooks/useMedia';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
var Button = (cov_x1j7yn8w6().s[0]++, forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      analyticsName = _ref.analyticsName,
      disabled = _ref.disabled,
      loading = _ref.loading,
      loadingText = _ref.loadingText,
      _onClick = _ref.onClick,
      type = _ref.type,
      success = _ref.success,
      onMouseDown = _ref.onMouseDown,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_x1j7yn8w6().f[0]++;
  var isDisabled = (cov_x1j7yn8w6().s[1]++, isNil(disabled) ? (cov_x1j7yn8w6().b[0][0]++, loading) : (cov_x1j7yn8w6().b[0][1]++, disabled));
  var spinnerColor = (cov_x1j7yn8w6().s[2]++, variant === 'primary' ? (cov_x1j7yn8w6().b[1][0]++, 'neutrals0') : (cov_x1j7yn8w6().b[1][1]++, 'neutrals100'));
  var displayLoadingText = (cov_x1j7yn8w6().s[3]++, variant === 'icon' ? (cov_x1j7yn8w6().b[2][0]++, null) : (cov_x1j7yn8w6().b[2][1]++, loadingText));
  var styles = (cov_x1j7yn8w6().s[4]++, useStyleConfig('Button', _objectSpread({
    variant: variant
  }, props)));
  var canNotHover = (cov_x1j7yn8w6().s[5]++, useMedia('(hover: none)'));

  var _ref2 = (cov_x1j7yn8w6().s[6]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent; // In other components (like Box), we only attach the inView handler if analyticsName
  // is defined. In this one, analyticsName is required, so we always attach.


  var _ref3 = (cov_x1j7yn8w6().s[7]++, useInView({
    // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
    // threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering. (set at 100% for now)
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_x1j7yn8w6().s[8]++;
  useEffect(function () {
    cov_x1j7yn8w6().f[1]++;
    cov_x1j7yn8w6().s[9]++;

    // this tracks impression events whenenver the button enters or leaves the viewpoint
    if (inView) {
      cov_x1j7yn8w6().b[3][0]++;
      cov_x1j7yn8w6().s[10]++;
      (cov_x1j7yn8w6().b[4][0]++, analyticsName) && (cov_x1j7yn8w6().b[4][1]++, trackUserEvent({
        buttonViewEvent: {
          targetName: analyticsName
        }
      }));
    } else {
      cov_x1j7yn8w6().b[3][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]); // Even though a touch device can't hover, after a button is tapped, it will
  // retain the hover state. Instead we will remove the hover state when it is not supported.

  cov_x1j7yn8w6().s[11]++;

  if (canNotHover) {
    cov_x1j7yn8w6().b[5][0]++;
    cov_x1j7yn8w6().s[12]++;
    delete styles['_hover'];
  } else {
    cov_x1j7yn8w6().b[5][1]++;
  }

  var successTransition = (cov_x1j7yn8w6().s[13]++, keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      0% {\n        background: var(--colors-brand50);\n      }\n\n      100% {\n        background: var(--colors-green50);\n      }\n    "]))));
  var onMouseEnter = (cov_x1j7yn8w6().s[14]++, useCallback(function () {
    cov_x1j7yn8w6().f[2]++;
    cov_x1j7yn8w6().s[15]++;
    return (cov_x1j7yn8w6().b[6][0]++, analyticsName) && (cov_x1j7yn8w6().b[6][1]++, trackUserEvent({
      buttonHoverEvent: {
        targetName: analyticsName
      }
    }));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName]));
  cov_x1j7yn8w6().s[16]++;
  return /*#__PURE__*/React.createElement(bricks.button, _extends({
    ref: useMergeRefs(inViewRef, ref),
    className: "cta-button" // __css has a lower priority than sx
    ,
    __css: styles,
    disabled: isDisabled,
    onClick: function onClick(e) {
      cov_x1j7yn8w6().f[3]++;
      cov_x1j7yn8w6().s[17]++;
      (cov_x1j7yn8w6().b[7][0]++, analyticsName) && (cov_x1j7yn8w6().b[7][1]++, trackUserEvent({
        buttonClickEvent: {
          targetName: analyticsName
        }
      }));
      cov_x1j7yn8w6().s[18]++;
      (cov_x1j7yn8w6().b[8][0]++, _onClick) && (cov_x1j7yn8w6().b[8][1]++, _onClick(e));
    },
    type: type,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    animation: success ? (cov_x1j7yn8w6().b[9][0]++, "".concat(successTransition, " 1s")) : (cov_x1j7yn8w6().b[9][1]++, null)
  }, props), loading ? (cov_x1j7yn8w6().b[10][0]++, /*#__PURE__*/React.createElement(ButtonSpinner, {
    color: spinnerColor
  })) : (cov_x1j7yn8w6().b[10][1]++, null), loading ? (cov_x1j7yn8w6().b[11][0]++, displayLoadingText) : (cov_x1j7yn8w6().b[11][1]++, children));
}));
cov_x1j7yn8w6().s[19]++;
Button.defaultProps = {
  variant: 'primary',
  loading: false,
  loadingText: 'Loading ...',
  size: 'md',
  type: 'button'
};
export default Button;
cov_x1j7yn8w6().s[20]++;
export var ButtonSpinner = function ButtonSpinner(_ref5) {
  var color = _ref5.color;
  cov_x1j7yn8w6().f[4]++;
  cov_x1j7yn8w6().s[21]++;
  return /*#__PURE__*/React.createElement(Box, {
    "data-testid": "button-spinner",
    transition: "all ease-in-out 0.1s",
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "20px",
    height: "20px",
    mt: "-10px",
    ml: "-10px",
    borderRadius: "rounded",
    border: "solid 3px transparent",
    color: "transparent",
    zIndex: 2,
    borderColor: color,
    borderBottomColor: "transparent",
    animation: "".concat(inProgressRotate, " 0.6s infinite linear"),
    _hover: {
      color: 'transparent'
    }
  });
};
var inProgressRotate = (cov_x1j7yn8w6().s[22]++, keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  to {\n    transform: rotate(360deg);\n  }\n"]))));